import { del, get, patch, post } from "aws-amplify/api";
import { API_NAME_VELAVU, normalizePromiseError, operationToJSON, operationToPaginatedJSON, paginateAPIOptions, simplifyStringRecord, valueToDocumentType, } from "../util/amplify-utils";
// Value that can be passed to GetAllDevicesParams.bbox
// to include all devices in the world.
// Useful to ensure that all devices have a location
// without enforcing any specific region.
export const GET_ALL_DEVICES_BBOX_ALL = [-180, -90, 180, 90];
export default class VelavuAPIDevices {
    //This method returns all of a customer's devices.
    getAllDevices(params, pagination) {
        //Convert the params to a query object
        const query = {};
        if (params?.category !== undefined) {
            query["category"] = params.category;
        }
        if (params?.siteID !== undefined) {
            query["site_id"] = params.siteID;
        }
        if (params?.geofenceID !== undefined) {
            query["geofence_id"] = params.geofenceID;
        }
        if (params?.bbox !== undefined) {
            query["bbox"] = params.bbox.join(",");
        }
        if (params?.hardware !== undefined) {
            query["hardware"] = params.hardware.join(",");
        }
        if (params?.model !== undefined) {
            query["model"] = params.model;
        }
        if (params?.paired !== undefined) {
            query["paired"] = String(params.paired);
        }
        if (params?.online !== undefined) {
            query["online"] = String(params.online);
        }
        if (params?.configConfirmed !== undefined) {
            query["config_confirmed"] = String(params.configConfirmed);
        }
        if (params?.onlyRegistered !== undefined) {
            query["only_registered"] = String(params.onlyRegistered);
        }
        if (params?.id !== undefined) {
            query["id"] = params.id;
        }
        return normalizePromiseError(operationToPaginatedJSON(get({
            apiName: API_NAME_VELAVU,
            path: "/devices",
            options: paginateAPIOptions(pagination, {
                queryParams: query,
            }),
        })));
    }
    //This request allows you to retrieve all stored data for a single device.
    getSpecificDevice(deviceID) {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: `/devices/${deviceID}`,
        })));
    }
    //This method allows you to query a device by ID or serial code.
    //This is useful for finding a device whose device ID is unknown or
    //seeing if a device can be registered to the user via POST api.velavu.com/devices.
    queryDeviceByIDOrSerial(params) {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: "/available",
            options: {
                queryParams: simplifyStringRecord(params),
            },
        })));
    }
    // This request allows you to register an existing available device to a customer.
    registerAvailableDevice(deviceID, params) {
        return normalizePromiseError(operationToJSON(post({
            apiName: API_NAME_VELAVU,
            path: `/devices/${deviceID}`,
            options: {
                body: params,
            },
        })));
    }
    // This request allows you to register a new device that does not exist in the Velavu backend.
    createNewDevice(params) {
        return normalizePromiseError(operationToJSON(post({
            apiName: API_NAME_VELAVU,
            path: "/devices",
            options: {
                body: params,
            },
        })));
    }
    //This endpoint modifies one or more properties of the device.
    modifySpecificDevice(deviceID, params) {
        return normalizePromiseError(operationToJSON(patch({
            apiName: API_NAME_VELAVU,
            path: `/devices/${deviceID}`,
            options: {
                body: valueToDocumentType(params),
            },
        })));
    }
    //This method makes a device become unlocked and sends a reset command to the device.
    // If the device is preprogrammed to a customer, it will self-provision to that customer's account again.
    deleteSpecificDevice(deviceID) {
        return normalizePromiseError(del({
            apiName: API_NAME_VELAVU,
            path: `/devices/${deviceID}`,
        }).response);
    }
    //This method reboots device, will only work if the device is currently online
    rebootSpecificDevice(deviceID) {
        return normalizePromiseError(post({
            apiName: API_NAME_VELAVU,
            path: `/devices/${deviceID}/reboot`,
        }).response);
    }
}
//# sourceMappingURL=velavu-api-devices.js.map